import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { AngularFireModule } from '@angular/fire';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireAnalyticsModule, ScreenTrackingService } from '@angular/fire/analytics';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { LoadingInterceptor } from './providers/loading.interceptor';
import { UserLocationComponent } from './components/user-location/user-location.component';
import { AlertComponent } from './components/alert/alert.component';
import { ReferFriendComponent } from './components/refer-friend/refer-friend.component';
import { LoadingCircleComponent } from './components/loading-circle/loading-circle.component';
import { AppSplashComponent } from './components/app-splash/app-splash.component';
import { SmartAudioService } from './providers/smart-audio.service';
import { InterestsComponent } from './components/interests/interests.component';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireAnalyticsModule,
    AgmCoreModule.forRoot({
      apiKey: environment.app.mapKey
    })
  ],
  declarations: [AppComponent, UserLocationComponent, AlertComponent, ReferFriendComponent, AppSplashComponent, LoadingCircleComponent, InterestsComponent],
  entryComponents: [UserLocationComponent],
  providers: [
    SplashScreen,
    StatusBar,
    ScreenTrackingService,
    AngularFireStorage,
    SmartAudioService,
    { provide: 'googleTagManagerId', useValue: environment.firebase.tagManagerId },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: LoadingInterceptor,
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
